import { request } from '@/shared/api/request'

export const getCountry = (params) => {
	return request({ url: 'dict/country/findOne', method: 'GET', params })
}
